import React, { useEffect, useState } from 'react';

import { Modal } from 'react-bootstrap';

import telegram from '../../../Icons/telegram.svg';

import { XLg } from 'react-bootstrap-icons';
import Green from '../../../Icons/modal-bg.png';

export default function PostModal({ isOpen, setIsOpen, postUpdate }) {
  const [textarea, setTextarea] = useState('');
  const [textError, setTextError] = useState('');
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    if (textarea.length === 280) setTextError('You have exceeded the 280 characters');
    else setTextError('');

    if (textarea.length === 0) {
      if (!isDisabled)
        setIsDisabled(true)
    } else {
      if (isDisabled)
        setIsDisabled(false)
    }
  }, [textarea, isDisabled]);

  return (
    <Modal show={isOpen} onHide={setIsOpen} centered>
      <Modal.Header className='d-flex justify-content-between align-items-center border-0 mb-3 relative'>
        <Modal.Title>Update</Modal.Title>
        <div className=' text-success '>
          <XLg
            style={{ zIndex: '2' }}
            className='relative cursor-pointer'
            onClick={() => setIsOpen(false)}
          />
        </div>
        <img
          alt='background'
          src={Green}
          className='absolute'
          style={{ top: '0px', right: '0px' }}
        />
      </Modal.Header>
      <Modal.Body>
        <div className='relative'>
          <textarea
            value={textarea}
            onChange={(e) => setTextarea(e.target.value)}
            className='border-success p-2 rounded'
            placeholder='Write your update'
            rows='6'
            maxlength='280'
            style={{ resize: 'none', backgroundColor: '#F1FBF0', width: '100%' }}
          ></textarea>
          <span className='absolute text-success' style={{ bottom: '.5rem', right: '.5rem' }}>
            {textarea ? textarea.length : 0}/280
          </span>
        </div>
        {textError && <p className='text-danger mt-2 mb-3'>{textError}</p>}
        <div className='mt-2 d-flex justify-content-between'>
          <button
            className='btn btn-outline-success rounded text-capitalize text-sm'
            onClick={() => setIsOpen(false)}
          >
            Cancel
          </button>
          <button
            disabled={isDisabled}
            className='btn btn-success border-success rounded text-capitalize text-sm'
            onClick={(e) => {
              e.preventDefault()
              postUpdate(textarea);
              setTextarea('')
            }}>
            <img src={telegram} alt='logo' className='mr-2 ' />
            Post
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
